import React, { useState } from 'react';
import { View, Image } from 'react-native';
import { Icon } from 'react-native-elements';
import { useDispatch } from 'react-redux';
import ActionModal from '../../../Componentsv1/ActionModal';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { social_updatePlayingPodcastEpisode } from '../../../store/actionsv1/social';
import { PodcastEpisodesProps } from "../../../store/types/soc_svc"
import { getPodEpisodeImage } from '../helpers/podcasts';


type PodcastEpisodeCardProps = {
    navigation:any,
    width:number,
    onShareExternal:() => void,
    view_mode:string,
    podcast_episode:PodcastEpisodesProps,
    hide_description?:boolean,
    playing?:boolean
}
const MAX_TITLE_LENGTH = 50
const MAX_DESC_LENGTH = 75
const PodcastEpisodeCard = ({ navigation, width, podcast_episode, playing, view_mode, hide_description, onShareExternal }:PodcastEpisodeCardProps) => {
    const [ action_visible, setActionVisible ] = useState(false);
    const dispatch = useDispatch()


    const handleEpisodeAction = (action:string) => {
        dispatch(social_updatePlayingPodcastEpisode(podcast_episode))
    }
    
    const handleOptionSelect = (option:any) => {
        switch(option.value){
            case 'share_external':
                return onShareExternal()
            case 'share_local':
                return navigation.navigate('SocialStack', { screen: 'MemoPost', initial:false, params: { type: 'podcast_episode', post_id:podcast_episode.podcast_episode_id } })

        }
    }
    
    let title = podcast_episode.title.length > MAX_TITLE_LENGTH ? `${podcast_episode.title.slice(0, MAX_TITLE_LENGTH)}...` : podcast_episode.title
    let description = podcast_episode.description_override ?? podcast_episode.description
    if(!description){ description = 'There is no description available for this episode' }
    description = description.length > MAX_DESC_LENGTH ? `${description.slice(0, MAX_DESC_LENGTH)}...` : description

    if(view_mode === 'share'){
        return (
            <View style={{ flexDirection:'row', width, margin:10, padding:10, borderWidth:1, borderColor:Colors.shades.shade100, borderRadius:8  }}>
                <Image source={getPodEpisodeImage(podcast_episode)} style={{ height:40, width:40, borderRadius:4 }} resizeMode='center' />
                <View style={{ marginLeft:5, flex:1 }}>
                    <Text size={14} color={Colors.brand.midnight} weight='semibold'>{title}</Text>
                    <Text size={12} color={Colors.brand.midnight} weight='regular' style={{ marginTop:5 }}>{description}</Text>
                </View>
            </View>
        )
    }

    return (
        <View style={{ width, borderRadius:4, borderWidth:1, borderColor:Colors.shades.shade600 }}>
            <TouchableOpacity onPress={() => handleEpisodeAction('play')}>
                <View style={{ marginBottom:5 }}>
                    <Image source={getPodEpisodeImage(podcast_episode)} style={{ height:width * 0.8, width, borderTopRightRadius:4, borderTopLeftRadius:4 }} resizeMode='cover' />
                    {playing ?
                    <View style={{ position: 'absolute', top:0, bottom:0, right:0, left:0, justifyContent:'center', alignItems:'center' }}>
                        <View style={{ height:20, width:20, borderRadius:100, backgroundColor:Colors.shades.white, justifyContent:'center', alignItems:'center' }}>
                            <Icon name='pause' type='feather' size={16} color={Colors.brand.midnight} /> 
                        </View>
                    </View>
                    :<></>}
                </View>
                <View style={{ padding:5 }}>
                    <Text textAlign='left' size={12} color={Colors.brand.midnight} weight='semibold'>{title}</Text>
                    {!hide_description ?
                    <Text textAlign='left' size={12} color={Colors.brand.midnight} weight='regular' style={{ marginTop:5 }}>{description}</Text>
                    :<></>}
                </View>
            </TouchableOpacity>
            {view_mode !== 'share' && !hide_description ?
            <View nativeID='podcast_episode_toolbar' style={{ flex:1, flexDirection:'row', alignItems:'center', padding:10, borderTopWidth:1, borderTopColor:Colors.shades.shade600, borderBottomRightRadius:4, borderBottomLeftRadius:4 }}>
                <View style={{ flex:7/8 }} />
                <TouchableOpacity style={{ flex:1/8, justifyContent:'center', alignItems:'flex-end' }} onPress={() => setActionVisible(true)}>
                    <Icon type='feather' name='share' size={16} color={Colors.brand.midnight} />
                </TouchableOpacity>
            </View>
            :<></>}
            <ActionModal 
                options={[{ value: 'share_local', label: 'Share & Create Post' }, { value: 'share_external', label: 'Share Externally' }]}
                label_attribute='label'
                onSelectOption={(option) => handleOptionSelect(option)}
                isVisible={action_visible}
                closeModal={() => setActionVisible(false)}
                />
        </View>
  
    )
}

export default React.memo(PodcastEpisodeCard, (left, right) => {
    if(left.width != right.width){ return false }
    if(left?.podcast_episode?.podcast_episode_id != right?.podcast_episode?.podcast_episode_id){ return false }
    return true
})